import { useState } from "react";

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const login = async (email, password) => {
    // console.debug("inside useLogin hook login async arrow function");
    setIsLoading(true);
    setError(null);

    const response = await fetch("/api/user/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, password })
    });
    //json is the object with email and token and role
    const json = await response.json();
    // console.debug("Inside Login hook json response: ", json);

    if (!response.ok) {
      setIsLoading(false);
      // console.debug("json.error: ", json.error);
      setError(json.msg);

      throw new Error(json.msg); // Throw an error with the message from the server
    }
    if (response.ok) {

      setIsLoading(false);

      // console.debug("INSIDE useLogin hook json.role: ", json.role);

      return json;
    }
  };

  return { login, error, isLoading };
};
